<div class="flex-column gap pb-3">
    <app-card-table
        tableKey="serviceDocumentPatterns"
        [tableTitle]="'service.patterns.document.title'"
        [columns]="columns"
        translatePrefix="service.patterns.document."
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId] }]]"
        [gridData]="$any(store.documentsPatterns$ | async)"
        [refreshCallback]="store.api.getServicePatterns"
        [showCreate]="store2.isAllowed('service.update')()"
        [showDetail]="store2.isAllowed('service.update')()"
        [showDelete]="store2.isAllowed('service.update')()"
        (detailCallback)="goTo('documents', $event)"
        (createCallback)="goTo('documents')"
        (deleteCallbackWithEvent)="deletePattern($event)"
    >
        <ng-template pTemplate="usage" let-data="data">
            {{ 'service.patterns.usage.' + (data?.startsWith('serviceAnnouncementType') ? 'serviceAnnouncementType' : data) | translate }}
        </ng-template>
    </app-card-table>

    <app-card-table
        tableKey="serviceStructurePatterns"
        [tableTitle]="'service.patterns.structure.title'"
        [columns]="columns"
        translatePrefix="service.patterns.structure."
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId] }]]"
        [gridData]="$any(store.structurePatterns$ | async)"
        [refreshCallback]="store.api.getServicePatterns"
        [showCreate]="store2.isAllowed('service.update')()"
        [showDetail]="store2.isAllowed('service.update')()"
        [showDelete]="store2.isAllowed('service.update')()"
        (detailCallback)="goTo('structures', $event)"
        (createCallback)="goTo('structures')"
        (deleteCallbackWithEvent)="deletePattern($event)"
    >
        <ng-template pTemplate="usage" let-data="data">
            {{ 'service.patterns.usage.' + (data?.startsWith('serviceAnnouncementType') ? 'serviceAnnouncementType' : data) | translate }}
        </ng-template>
    </app-card-table>

</div>
